import { CustomComponentProps } from "utils/types/generalTypes";

export type ToolTipProps = CustomComponentProps & {
    text: string;
};

const ToolTip = ({ text }: ToolTipProps) => {
    return (
        <div className="tooltip">
            <div className="momeento-svg info-svg svg-18"></div>
            <span className="tooltiptext momeento-p">{text}</span>
        </div>
    );
};

export default ToolTip;
